<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-06-28 13:27:43
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-07-31 10:21:09
 * @FilePath: /wemeet-admin-new/src/views/data/components/trendAnalysis.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div class="dialogCard" style="margin-top: 20px; width: 100%">
    <div class="subBox">
      <div class="title">
        <span>趋势分析</span>
        <!-- <el-tooltip effect="dark" content="用户访问人数、报名、签到等关键数据，连续多天的趋势" placement="top-start">
          <img src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/WeMeet-mini/tips.png" alt="" class="tipsIcon">
        </el-tooltip> -->
      </div>
      <div class="chooseTime">
        <span class="timeLabel">选择时间</span>
        <el-date-picker
          v-model="timeRange"
          :disabled-date="disabledDate"
          end-placeholder="结束时间"
          range-separator="-"
          :shortcuts="shortcuts"
          start-placeholder="开始时间"
          type="daterange"
          @calendar-change="handleChange"
          @change="pickerChange"
          @focus="handleFocus"
        />
      </div>
    </div>

    <el-row>
      <div v-if="loading">加载中...</div>
      <template v-else>
        <el-col v-if="!emptyFlag" :lg="24" :md="24" :sm="24" :xl="24" :xs="24">
          <vab-chart :option="option" style="height: 390px; width: 100%" theme="vab-echarts-theme" />
        </el-col>

        <noDataVue v-else />

        <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" />
      </template>
    </el-row>
  </div>
</template>

<script>
  import { defineComponent, reactive, toRefs, ref, watch } from 'vue'
  import _ from 'lodash'
  import VabChart from '@/extra/VabChart'
  import VabCount from '@/extra/VabCount'
  import noDataVue from './noData.vue'

  export default defineComponent({
    components: {
      VabChart,
      VabCount,
      noDataVue,
    },
    props: {
      trendAnalysis: {
        type: Array,
        default: [],
      },
    },
    setup(props, { emit }) {
      watch(
        () => props.trendAnalysis,
        (newVal, oldVal) => {
          console.log(newVal, '====s.')
          if (newVal.length == 0) {
            state.emptyFlag = true
          } else {
            state.emptyFlag = false
            handleOption(newVal)
          }
          setTimeout(() => {
            state.loading = false
          }, 100)
        },
        {
          deep: true,
        }
      )
      // 监听时间范围的变化

      const handleRangeChange = (e) => {
        console.log(e)
      }

      const state = reactive({
        loading: true,
        timeRange: [null, null],
        chooseDay: null,
        emptyFlag: false,
        shortcuts: [
          {
            text: '上一周',
            value: () => {
              const end = new Date()
              const start = new Date()
              start.setDate(start.getDate() - 7)
              return [start, end]
            },
          },
          {
            text: '上个月',
            value: () => {
              const end = new Date()
              const start = new Date()
              start.setMonth(start.getMonth() - 1)
              return [start, end]
            },
          },
        ],
        option: {
          autoSize: false, // 关闭自适应大小
          grid: {
            left: 30,
            right: 10,
            top: 50,
            bottom: 50,
            containLabel: true, // 如果使用坐标轴刻度标签也应当保证适应
          },
          tooltip: {
            trigger: 'axis',
            formatter: function (params) {
              let str = params[0].name + '<br/>'
              let value1 =
                params[0].marker +
                params[0].seriesName +
                `<span style='width:10px;display: inline-block;'></span>` +
                params[0].value +
                '人' +
                '<br/>'
              let value2 =
                params[1].marker +
                params[1].seriesName +
                `<span style='width:10px;display: inline-block;'></span>` +
                params[1].value +
                '人' +
                '<br/>'
              let value3 =
                params[2].marker +
                params[2].seriesName +
                `<span style='width:10px;display: inline-block;'></span>` +
                params[2].value +
                '人' +
                '<br/>'
              str += value1 + value2 + value3
              return str
            },
            axisPointer: {
              type: 'cross',
              crossStyle: {
                color: '#999',
              },
            },
          },

          legend: {
            data: ['注册', '签到', '访问人数'],
            left: `center`,
            top: 'bottom',
            orient: 'horizontal',
          },
          xAxis: [
            {
              type: 'category',
              data: [],
              axisPointer: {
                type: 'shadow',
              },
              splitLine: {
                show: false,
              },
            },
          ],
          yAxis: [
            {
              type: 'value',
              name: '单位（人）',
              nameTextStyle: {
                color: '#4e5969',
              },
              axisLabel: {
                formatter: '{value}',
              },
            },
          ],
          series: [],
        },
      })

      const handleOption = (data) => {
        let xData = []
        let seriesData = [
          {
            name: '注册',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value
              },
            },
            data: [],
          },
          {
            name: '签到',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value
              },
            },
            data: [],
          },
          {
            name: '访问人数',
            type: 'line',
            tooltip: {
              valueFormatter: function (value) {
                return value
              },
            },
            data: [],
          },
        ]
        data.forEach((v) => {
          xData.push(v.date)
          seriesData[0].data.push(v.meetingSignUpNum)
          seriesData[1].data.push(v.meetingSignInNum)
          seriesData[2].data.push(v.userVisitNum)
        })
        state.option.xAxis[0].data = xData
        state.option.series = seriesData
      }
      const handleChange = (val) => {
        console.log(val)
        const [pointDay] = val
        state.chooseDay = pointDay
        console.log(pointDay)
      }

      const pickerChange = (val) => {
        console.log(val, '=-==')
        emit('changeTrends', val)
      }
      //取值方法
      const handleFocus = () => {
        state.chooseDay = null
      }
      const disabledDate = (time) => {
        if (!state.chooseDay) {
          return false
        }
        let timeRange = 30
        const con1 = new Date(state.chooseDay).getTime() - timeRange * 24 * 60 * 60 * 1000
        const con2 = new Date(state.chooseDay).getTime() + timeRange * 24 * 60 * 60 * 1000
        return time < con1 || time > con2
      }

      window.onresize = () => {
        console.log(`resize`)
      }
      return {
        ...toRefs(state),
        handleChange,
        handleFocus,
        disabledDate,
        pickerChange,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .dialogCard {
    width: 100%;
    min-height: 174px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    padding: 20px;
    box-sizing: border-box;
    .subBox {
      display: flex;
      justify-content: space-between;
      .title {
        font-weight: 500;
        font-size: 16px;
        color: #1d2129;
        margin-bottom: 4px;
        display: flex;
        align-items: center;
        .tipsIcon {
          width: 18px;
          height: 18px;
          margin-left: 8px;
        }
      }
      .chooseTime {
        .timeLabel {
          font-size: 14px;
          color: #4e5969;
          margin-right: 16px;
        }
      }
    }
  }
</style>
